export interface LogEntity {
    message?: string;
    logLevel?: LogLevel
}

export enum LogLevel {
    Trace,
    Debug,
    Info,
    Warn,
    Error,
    Fatal
}